<template>
	<div>
		<Header></Header>
		<loginheader flagg="1" num="6"></loginheader>
		<div class="Cartoon-con">
			<publiccartoon v-for="(item, index) in cartoon.data" :key="index" :cartoon="item"></publiccartoon>
		</div>
		<div class="Cartoon-foot">
			<publicpaging :total="page" pagesize="12"></publicpaging>
		</div>
		<Fotter></Fotter>
	</div>
</template>

<script>
	import Header from "../Header.vue";
	import Fotter from "../Fotter.vue";
	import loginheader from "../loginheader.vue";
	import publiccartoon from "../publiccartoon.vue";
	import publicpaging from "../publicpaging.vue";

	export default {
		name: "App",
		data() {
			return {
				cartoon: "",
				page: ""
			};
		},
		components: {
			Header,
			Fotter,
			loginheader,
			publiccartoon,
			publicpaging
		},
		methods: {
			getpagedata(page = 1, size = 12) {
				this.$http.get(`cartoon/5?page=${page}&size=${size}`).then(res => {
					this.cartoon = res.body.data;
				});
			}
		},
		beforeCreate() {
			this.$http.get(`cartoon/5?page=1&size=12`).then(res => {
				this.cartoon = res.data.data;
				this.page = res.body.data.total;
			});
		}
	};
</script>

<style>
	.Cartoon-con {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		table-layout: fixed;
		word-break: break-all;
		overflow: hidden;
	}

	.Cartoon-foot {
		width: 1200px;
		margin: 40px auto;
		display: flex;
		justify-content: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/Cartoon/Cartoon.vue